
import './vidoes.scss';
import React, { useLayoutEffect, useState } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';
import { Trans, useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router';
import ModalOpenButton from '../../components/common/modal';
import StopMotionSvg from '../../components/StopMotionSvg';
import DashedDrawedSvg from '../../components/DashedDrawedSvg';
import * as images from './vidoes-images';
import CommonButton from '../../components/button/button';
import CommonVideo from '../../components/common/common-video';
import FilmRoll from './film-roll/film-roll';
import useDeviceDetection from '../../hooks/useDeviceDetection';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import useIsRTL from '../../hooks/use-is-rtl';

function Vidoes() {

  const { reloadState } = useOutletContext();

  const [t, isRtl] = useIsRTL();
  const rtlMulFactor = 1;
  const [interval, setInterval] = useState(null);
  const deviceType = useDeviceDetection();

  useLayoutEffect(() => {
    window.scrollTo({ top: 0 });
    reloadState[1](false);
  }, []);

  useGSAP((context) => {

    //#region section 1

    gsap.to('#vidoes-header', {
      scrollTrigger: {
        trigger: '#section1',
        start: 'top top',
        end: 'bottom top',
        scrub: true,
      },
      scale: 1.3
    });
    //#endregion

    //#region section 2
    const tl = gsap.timeline();
    ScrollTrigger.create({
      animation: tl,
      trigger: '.section-2',
      start: "top 70%",
      end: '10% 20%',
      scrub: true
    });
    tl.fromTo(".section-2 .row .item",
      {
        autoAlpha: 0,
        y: 100,
      },
      {
        autoAlpha: 1,
        y: 0,
        duration: 1,
        stagger: .35
      }
    )
      .add(() => setInterval(i => !i ? 400 : null), '-=0.2')
    //#endregion

    //#region section 4

    gsap.from('#teamTable img', {
      scrollTrigger: {
        trigger: '#teamTable',
        start: 'top bottom',
        end: 'top 18%',
        scrub: 1,
      },
      xPercent: 70,
      yPercent: -20,
      opacity: 0.2,
    });
    //#endregion

    //#region section 6
    tl.from('#action', {
      scrollTrigger: {
        trigger: '#section4',
        endTrigger: '#action',
        start: 'bottom top',
        end: 'bottom 98%',
        scrub: 1,
      },
      xPercent: -100,
      opacity: 0.5,
    });
    //#endregion

    //#region section 8 woman postcard entering
    gsap.timeline({
      scrollTrigger: {
        trigger: '#background-image',
        start: 'top bottom',
        end: 'bottom top',
        scrub: 1,
      }
    }).fromTo(
      '#postcard',
      { xPercent: 100, opacity: 0.3, y: -30 }, {
      xPercent: 20, y: 0, opacity: 1, duration: 2,// ease: 'expo.out'
    }
    )
      // .to('#postcard',
      //   {
      //     xPercent: isRtl * (-90),
      //     opacity: 1,
      //     duration: 5
      //   }, 1')
      .to('#postcard',
        {
          xPercent: (-50),
          opacity: 1,
          duration: 6,
          ease: 'expo.inOut'
        })
    // .to('#postcard',
    // {
    //   xPercent: isRtl * (-100),
    //   opacity: 1,
    //   duration: 1,
    //   ease: 'expo.in'
    // });
    //#endregion

    //#region section 10 - sea man go up    

    gsap.from('#sea-man', {
      scrollTrigger: {
        trigger: '#section10',
        start: "top center",
        end: "center 40%",
        scrub: 1,
      },
      yPercent: deviceType?.isMobile ? 20 : 80,
      // opacity: 0,
    });
    //#endregion

    //#region - section 12 selfi man entering
    gsap.from('#selfiMan', {
      scrollTrigger: {
        trigger: '#section11',
        start: 'top top',
        end: 'bottom top',
        scrub: 0.5,
      },
      xPercent: 100 * rtlMulFactor,
      opacity: 0,
    });
    //#endregion

    //#region section 13 -  prouductions row go up on e after onother

    const boxesTl = gsap.timeline();

    ScrollTrigger.create({
      animation: boxesTl,
      trigger: '.section-13',
      endTrigger: '.section-13 .sub-title',
      start: "top 70%",
      end: 'top 20%',
      scrub: true
    });

    boxesTl.fromTo(".section-13 .productions .box",
      {
        autoAlpha: 0,
        y: 30,
      },
      {
        autoAlpha: 1,
        y: 0,
        stagger: .8,
        ease: 'power1.out'
      }
    )

    //#endregion

    //#region dancing items

    // section 3 arrow  and text

    if (!deviceType?.isMobile) {
      gsap.set('#dancingHowText', {
        transformOrigin: 'right center', rotate: 0
      });

      gsap.timeline({ repeat: -1, })
        .set('#dancingHowText', { rotate: 8, }, 0)
        .set('#dancingHowText', { rotate: -6 }, 0.6)
        .set('#dancingHowText', { rotate: 8, }, 1.2)
        .set('#section3Arrow2Heads', { rotate: -8, y: 30 }, 0)
        .set('#section3Arrow2Heads', { rotate: 6, y: 30 }, 0.6)
        .set('#section3Arrow2Heads', { rotate: -8, y: 30 }, 1.2);
    }
    //section 6 arrow
    gsap.timeline({ repeat: -1 })
      .to('button#start', { scale: 1.2, duration: 0.8 })
      .to('button#start', { scale: 1, duration: 0.8 }, '+=0.05')

      // section 8 button
      .to('.section-8 button', { scale: 1.2, duration: 0.6 })
      .to('.section-8 button', { scale: 1, duration: 0.6 }, '+=0.05')

    // section 10  
    if (!deviceType?.isMobile) {
      gsap.timeline({ repeat: -1 })
        .set('#swimming-text', { rotate: 0 }, 0)
        .set('#swimming-text', { rotate: 8 }, 0.4)
        .set('#swimming-text', { rotate: 1 }, 0.8)
        .set('#swimming-text', { rotate: 8 }, 1.2)
        .set('#swimming-text', { rotate: 0 }, 1.6)
    }
    else {
      gsap.set('#swimming-text', { rotate: 0 }, 0)
    }
    gsap.timeline({ repeat: -1 })
      .to('.section-10 button', { scale: 1.2, duration: 0.8 })
      .to('.section-10 button', { scale: 1, duration: 0.8 }, '+=0.05')

    // section 12
    gsap.timeline({ repeat: -1 })
      .set('#hand', { rotate: 0, x: 0, y: 0 }, 0)
      .set('#hand', { rotate: 3, x: 5, y: 6 }, 0.4)
      .set('#hand', { rotate: 0, x: 10, y: 16 }, 0.8)
      .set('#hand', { rotate: 3, x: 5, y: 6 }, 1.2)
      .set('#hand', { rotate: 0, x: 0, y: 0 }, 1.6);
    // section 8 button

    gsap.timeline({ repeat: -1 })
      .to('.section-12 .peek-here', { scale: 1.1, duration: 1 }, '+=2.4')
      .to('.section-12 .peek-here', { scale: 1, duration: 1 }, '+=0.15')

    // section 14
    gsap.timeline({ repeat: -1 })
      .set('#section14 #firstTringle', { x: -3 }, 0)
      .set('#section14 #firstTringle', { x: 4 }, 0.6)
      .set('#section14 #firstTringle', { x: 0 }, 1.2)
      .set('#section14 #firstTringle', { x: 4 }, 1.8)
      .set('#section14 #firstTringle', { x: -3 }, 2.4)
      .set('#section14 #secondTringle', { y: 0 }, 0)
      .set('#section14 #secondTringle', { y: -3 }, 0.6)
      .set('#section14 #secondTringle', { y: 4 }, 1.2)
      .set('#section14 #secondTringle', { y: -3 }, 1.8)
      .set('#section14 #secondTringle', { y: -0 }, 2.4)

    //#endregion


    setTimeout(() => {
      // Ensure ScrollTrigger recalculates positions
      ScrollTrigger.refresh();
    }, 100);

    return () => {
      context.kill();
    }

  }, { dependencies: [deviceType?.isMobile] })

  return (<>
    <div className='vidoes-component'>
      {/* section 1 */}
      <section className='section-1' id="section1">
        <h1 id="vidoes-header" className='headline'>{t('vidoes.Vidoes')}</h1>
      </section>

      {/* section 2 */}
      <section className='section-2' id="section2">
        <div className='sub-title'>
          <Trans i18nKey="vidoes.What do we product">
            What do we <span className='marked-text'>product</span>?
          </Trans>
        </div>
        <div className='productions-types' id='productions-types'>
          <div className="row">
            {images.productionsTypes.map((item, index) => (
              <div className="item" key={`item${index}`}>
                <div className='dancing-lines-container' width={item.width} height={item.height} style={{ margin: item.margin, marginInlineStart: item.marginInlineStart }}>
                  <StopMotionSvg
                    shapes={item.shapes}
                    width={item.width}
                    height={item.height}
                    interval={interval}
                  />
                </div>
                <div className={`related-image ${item.name}`} key={`item${index}`}>
                  <img src={item.img} alt={t(item.description)} />
                </div>
                <p className={`${item.name}-p`} >{t(item.description)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* section 3 */}
      {deviceType?.isMobile ?
        <div className="mobile-dash-line" id="mobile-dash-line-1">
          <DashedDrawedSvg
            svgWidth="231"
            svgHeight="200"
            d="M170.69 4.07219C198.118 -1.01181 288.625 54.0768 166.449 67.9413C-1.49983 87.0001 213.589 108.157 2.30397 196.221"
            strokeDasharray={340} maskStrokDashArrayc='11' strokeWidth={11}
            trigger='#mobile-dash-line-1' startTrigger="top 95%" endTrigger="bottom 10%"
          />
        </div> : <section className='section-3' id="section3">
          <div className='transition-1' id="transition-1">
            <DashedDrawedSvg d='M692.993 5.54464C116.431 -6.81399 455.747 194.837 184.075 133.879C-118.192 66.0549 40.8488 260.49 109.229 276.723' strokeDasharray='1140'
              svgWidth='694' svgHeight='282'
              trigger='#section3' startTrigger="top 85%" endTrigger="bottom 10%" />
          </div>
        </section>
      }

      {/* section 4 */}
      <section className='section-4' id="section4">
        <div className='sub-title'>
          {t('vidoes.section4.but')}
          <span className='dancing-container'>
            <span className='marked-text' id="dancingHowText">{t('vidoes.section4.how')}</span>
            {images.section3Arrow2Heads}
          </span>
        </div>
        <div className='teamTable' id="teamTable">
          <img src={images.teamTable} alt='' />
        </div>
      </section >

      {/* section 5 */}
      {deviceType?.isMobile ?
        <div className="mobile-dash-line" id="mobile-dash-line-2">
          <DashedDrawedSvg
            svgWidth="201" svgHeight="166"
            d="M145.187 6.23021C221.72 92.0196 26.3217 -9.51468 144.023 118.786C195.519 174.918 81.3461 151.829 65.3636 142.293"
            strokeDasharray={340} maskStrokDashArrayc='11' strokeWidth={11}
            trigger='#mobile-dash-line-2' startTrigger="top 85%" endTrigger="bottom 10%" />
        </div>
        : < section className='section-5' id="section5" >
          <div className='transition-2'>
            <DashedDrawedSvg d='M584.771 5.47075C653.151 21.7029 812.192 216.138 509.925 148.315C238.253 87.3561 577.569 289.007 1.00676 276.649'
              strokeDasharray='1140' svgWidth='694' svgHeight='283'
              trigger='#section5' startTrigger="top 70%" endTrigger="bottom 5%" />
          </div>
        </section >
      }


      {/* section 6 */}
      < section className='section-6' id="section6" >
        <div className='sub-title'>
          <span className='span1'>{t('vidoes.Humor and emotions support learning processes')}</span>
          <div className='sub-label'>
            {images.arrow6Svg}
            <span className='span2'>{t('vidoes.How do we know')}</span>
          </div>
        </div>
        <div className='vidoe'>
          {images.orangeLines}
          <div style={{ position: 'relative' }}>
            <CommonVideo
              src={'https://qa.lnet.co.il/media/omor_rgesh.mp4'}
              style={{ width: '654.274px', height: '368.848px' }}
              description={t('monday')}
              posterSrc={images.vidoeImag}
              additonlPushLogic={(() => gsap.timeline().set('.action', { zIndex: 1 }).to('.action img', {
                xPercent: 0,
                opacity: 1,
              }))}

              playButton={onClick => <button onClick={() =>
                gsap.timeline().to('.action img', {
                  xPercent: (-100),
                  opacity: 0,
                }).add(onClick()).set('.action', { zIndex: -1 })
              }
                type='button' aria-label={t('vidoes.watch')} tabIndex="true" className="start play-circle-button" id='start'>
                <FontAwesomeIcon icon={faPlay} />
              </button>}
            />
            <div className='action'>
              <img src={images.action} id='action' alt='' />
              {images.purpleVidoeLayer}
            </div>
          </div>
        </div>
      </section >

      {/* section 7 */}
      {deviceType?.isMobile ?
        <div className="mobile-dash-line" id="mobile-dash-line-3">
          <DashedDrawedSvg
            svgWidth="229"
            svgHeight="137"
            d="M1.73198 5.53131C19.0734 0.68412 174.206 3.60933 135.967 40.4166C48.5643 124.546 271.019 77.8325 215.829 134.508"
            strokeDasharray={340} maskStrokDashArrayc='11' strokeWidth={11}
            trigger='#mobile-dash-line-3' startTrigger="top 95%" endTrigger="bottom 10%"
          />
        </div>
        : < section className='section-7' id="section7" >
          <div className='transition-3'>
            <DashedDrawedSvg d='M2.49988 8.8896C34.102 -6.32557 322.316 36.9773 258.688 123.126C113.255 320.034 588.766 175.487 497.757 306.977'
              strokeDasharray='740' svgWidth='520' svgHeight='245' diffrentTriggerEnd='#section7'
              trigger='.transition-3' startTrigger="top 80%" endTrigger="bottom 30%" />
          </div>
        </section >
      }

      {/* section 8 */}
      < section className='section-8' id="section8" >
        <div className='text-lable' id="trend-text">
          <span className='text-run'>{t('vidoes.Social networks lead the hottest trends')}</span>
          <div className='clip' id='clip'>
            {images.arrow8Svg}
            <ModalOpenButton content={{ commonVidoe: 'social-networks', vidoePoster: images.socialNetworksPoster, text: t('vidoes.Social networks lead the hottest trends') }}
              modalType={'fade'}
              triggerButton={onClick =>
                <button onClick={onClick} type='button' aria-label='לצפיה בטרנדים החמים' tabIndex="true" className='play-circle-button'><FontAwesomeIcon icon={faPlay} /></button>
              } />
          </div>
        </div>
        <div className='background-image' id="background-image">
          {images.backgroundGreenRoute}
          <img id="postcard" src={images.postcard} alt='' />
        </div>
      </section >

      {/* section 9 */}
      {deviceType?.isMobile ?
        <div className="mobile-dash-line" id="mobile-dash-line-4">
          <DashedDrawedSvg
            svgWidth="229"
            svgHeight="137"
            d="M227.268 5.53131C209.927 0.68412 54.7936 3.60933 93.0331 40.4166C180.436 124.546 -42.0193 77.8325 13.171 134.508"
            strokeDasharray={340} maskStrokDashArrayc='11' strokeWidth={11}
            trigger='#mobile-dash-line-4' startTrigger="top 95%" endTrigger="bottom 10%"
          />
        </div>
        : < section className='section-9' id='section9' >
          <div className='transition-4'>
            <DashedDrawedSvg d='M439.192 9.40894C405.468 -0.0175104 103.777 5.67121 178.143 77.2513C348.117 240.859 -84.4973 150.015 22.8327 260.233'
              strokeDasharray='740' svgWidth='441' svgHeight='264'
              trigger='#section9' startTrigger="top 70%" endTrigger="bottom 10%" />
          </div>
        </section >
      }

      {/* section 10 */}
      < section className="section-10" id="section10" >
        <div className='text-container'>
          <span>{t('vidoes.Interesting presenters are always a great addition')}</span>
          <div className="duck" id="duck">
            <div className="text-lable">
              <span id='swimming-text'>{t('vidoes.Come swim with us')}</span>
              {images.arrow10Svg}
            </div>
            <ModalOpenButton content={{ commonVidoe: 'tovim_byoter', vidoePoster: images.teachersAndPresentorImg, text: t('vidoes.Interesting presenters are always a great addition') }} modalType={'fade'}
              triggerButton={onClick =>
                <button onClick={onClick} type='button' aria-label={t('vidoes.Come swim with us')} tabIndex="true" className="img-duck play-circle-button">
                  <img src={images.duck} alt='' /><FontAwesomeIcon icon={faPlay} />
                </button>
              } /> </div>
        </div>
        <div className='sea' id='sea'>
          <img src={images.seaTop} className='sea-top' alt='' />
          <img src={images.seaMan} id="sea-man" alt='' />
          <img src={images.seaBottom} alt='' className='sea-bottom' />
        </div>
      </section >

      {/* section 11 */}
      {deviceType?.isMobile ?
        <div className="mobile-dash-line" id="mobile-dash-line-5">
          <DashedDrawedSvg
            svgWidth="177"
            svgHeight="161"
            d="M29.6617 4.58046C43.7496 9.78253 187.614 98.0824 153.186 102.613C74.4966 112.967 175.892 147.817 125.746 156.531"
            strokeDasharray={340} maskStrokDashArrayc='11' strokeWidth={11}
            trigger='#mobile-dash-line-5' startTrigger="top 95%" endTrigger="bottom 10%"
          />
        </div>
        : < section className='section-11' id='section11' >
          <div className='transition-5'>
            <DashedDrawedSvg d='M1.59777 5.07433C27.4047 12.0205 283.221 150.836 216.37 167.135C63.5705 204.39 249.881 249.384 152.043 277.208'
              strokeDasharray='640' svgWidth='230' svgHeight='283'
              trigger='#sea' startTrigger="top 20%" diffrentTriggerEnd='#section12' endTrigger="bottom center" />
          </div>
        </section >
      }

      {/* section 12 */}
      < section className='section-12' id='section12' >
        <div className='display-1'>
          <span>{t('vidoes.Animators not just at Pixar but with us too')}</span>
          <img id='selfiMan' src={images.selfiMan} alt='' />
        </div>
        <div className='display-2'>
          <div className='peek-here' alt={t('general.click here')}>
            <img src={images.property} alt='' />
            <ModalOpenButton content={{ commonVidoe: 'animation', vidoePoster: images.pixarPosterImg, text: t('vidoes.Animators not just at Pixar but with us too'), start: 27 }} modalType={'fade'}
              triggerButton={onClick =>
                <button onClick={onClick} type='button' aria-label={t('general.click here')} tabIndex="true" className='play-button'>{images.play}</button>
              } />
          </div>
          {!deviceType?.isMobile && <div className='hand'>
            <img id='hand' src={images.hand} alt='' />
            {images.gridBoardSvg}
          </div>}
        </div>
      </section >

      {/* section 13 */}
      < section className='section-13' id='section13' >
        <div className='sub-title'>
          <Trans i18nKey="vidoes.So what do our productions include">
            So what do our <span className='marked-text'>productions</span> include?
          </Trans>
        </div>

        <div className='productions'>
          {images.productionsTypesBox.map((item, index) => (
            <div className="box" key={`item${index}`}>
              <img src={item.img} name={`related-image ${index}`} alt={t(item.description)} />
              <span>{t(item.description)}</span>
            </div>
          ))}
        </div>
      </section >
      {deviceType?.isMobile && (
        <div className="mobile-dash-line" id="mobile-dash-line-9">
          <DashedDrawedSvg
            svgWidth="201" svgHeight="196"
            d="M68.028 2.28762C58.0904 15.3667 51.8502 135.761 87.1827 116.593C167.941 72.7817 85.0454 214.033 137.865 187.683"
            strokeDasharray={340} maskStrokDashArrayc='11' strokeWidth={11}
            trigger='#mobile-dash-line-9' startTrigger="top 85%" endTrigger="bottom 10%" />
        </div>
      )}
      {/* section 14 */}
      < section className='section-14' id='section14' >
        <div className='yalla'>
          <div className='sub-title'>
            <Trans i18nKey="vidoes.Ready to create with us a vidoe that all the company will talk about">
              Ready to create with us <span className='marked-text'>a vidoe</span>  that all the company will talk about</Trans>?
          </div>
          <div>
            <CommonButton
              text={t('vidoes.ceuButton')}
              fontFamily="Fb Gazoz"
              routePath='/contact-us'
            />
          </div>
        </div>
        <div className='filim'>
          <div className='arrows'>
            {images.greenTringles}
          </div>

          <div className='film-container' >
            <FilmRoll />
          </div>

        </div>
      </section >
      <div><div></div></div>

    </div >
  </>);
}

export default Vidoes;

